import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationAndTitleSubForm, Schema as SalutationAndTitleSchema } from '../subforms/SalutationAndTitle';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { OtherInformationFormalSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformationFormal';
import { AdditionalConsentSubForm } from '../subforms/AdditionalConsent';
import { DocumentsStandardSubForm, Schema as DocumentsStandardSchema } from '../subforms/DocumentsStandard';
import { PrivacyConsentSubForm } from '../subforms/PrivacyConsentFormal';

export const MBNKurzbewerbungSchema = (settings) => (
    Yup.object()
        .concat(SalutationAndTitleSchema(settings))
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(DocumentsStandardSchema(settings))
);

export const MBNKurzbewerbung = (props) => {
    const { colors, settings, dataSecurityUrl } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationAndTitleSubForm} colors={colors} settings={settings} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationFormalSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} />
            <Field component={DocumentsStandardSubForm} colors={colors} settings={settings} />
            <Field component={PrivacyConsentSubForm} dataSecurityUrl={dataSecurityUrl} />
        </>
    );
}